module.exports = __webpack_public_path__ + "img/3.900cb9a4.png";